/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Ritesh Sargam Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Ritesh Sargam Portfolio",
    type: "website",
    url: "http://riteshsargam.com/",
  },
};

//Home Page
const greeting = {
  title: "Ritesh Sargam ",
  logo_name: "RiteshSargam ",
  // nickname: "layman_brother",
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/1FvvQ4QyWriHRotGHUtdPIW4Nku9GDKX9/view?usp=sharing",
  portfolio_repository: "https://github.com/riteshsargam",
  githubProfile: "https://github.com/riteshsargam",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/riteshsargam",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ritesh-sargam/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:ritesh.sargam00@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Backend Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Developing RESTful APIs using ASP.NET Core Web API",
        "⚡ Implementing JWT-based authentication and role-based access control",
        "⚡ Handling database operations using SQL Server, PostgreSQL, MySQL, and MongoDB",
        "⚡ Applying Clean Architecture, CQRS, and Repository Pattern for scalability",
        "⚡ Integrating logging and monitoring using Serilog, ELK Stack, and Application Insights",
        "⚡ Implementing caching and messaging with Redis and RabbitMQ",
        "⚡ Ensuring fault tolerance using Polly for resilience strategies",
        "⚡ Working with microservices using Ocelot API Gateway and Azure API Management",
      ],
      softwareSkills: [
        { skillName: "C#", fontAwesomeClassname: "simple-icons:csharp", style: { color: "#239120" } },
        { skillName: "ASP.NET Core", fontAwesomeClassname: "simple-icons:dotnet", style: { color: "#512BD4" } },
        { skillName: "SQL Server", fontAwesomeClassname: "simple-icons:microsoftsqlserver", style: { color: "#CC2927" } },
        { skillName: "PostgreSQL", fontAwesomeClassname: "simple-icons:postgresql", style: { color: "#336791" } },
        { skillName: "MongoDB", fontAwesomeClassname: "simple-icons:mongodb", style: { color: "#47A248" } },
        { skillName: "Docker", fontAwesomeClassname: "simple-icons:docker", style: { color: "#1488C6" } },
        { skillName: "Kubernetes", fontAwesomeClassname: "simple-icons:kubernetes", style: { color: "#326CE5" } },
        { skillName: "Azure DevOps", fontAwesomeClassname: "simple-icons:azuredevops", style: { color: "#0078D7" } },
        { skillName: "RabbitMQ", fontAwesomeClassname: "simple-icons:rabbitmq", style: { color: "#FF6600" } },
        { skillName: "Redis", fontAwesomeClassname: "simple-icons:redis", style: { color: "#DC382D" } },
      ],
    },
    {
      title: "Frontend Development",
      fileName: "DesignImg",
      skills: [
        "⚡ Building dynamic and responsive user interfaces using Angular",
        "⚡ Implementing state management and efficient data binding",
        "⚡ Integrating RESTful APIs with Angular for seamless backend communication",
        "⚡ Creating interactive dashboards with real-time stock data visualization",
      ],
      softwareSkills: [
        { skillName: "HTML5", fontAwesomeClassname: "simple-icons:html5", style: { color: "#E34F26" } },
        { skillName: "CSS3", fontAwesomeClassname: "fa-css3", style: { color: "#1572B6" } },
        { skillName: "JavaScript", fontAwesomeClassname: "simple-icons:javascript", style: { backgroundColor: "#000000", color: "#F7DF1E" } },
        { skillName: "Angular", fontAwesomeClassname: "simple-icons:angular", style: { color: "#DD0031" } },
      ],
    },
    {
      title: "DevOps & Cloud",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Containerizing applications using Docker for scalability",
        "⚡ Orchestrating microservices with Kubernetes and Azure Kubernetes Service (AKS)",
        "⚡ Automating deployments using CI/CD pipelines in Azure DevOps",
        "⚡ Managing API gateways with Ocelot API Gateway and Azure API Management",
        "⚡ Securing cloud applications with Microsoft Entra ID B2C",
        "⚡ Storing secrets securely using Azure Key Vault",
      ],
      softwareSkills: [
        { skillName: "Docker", fontAwesomeClassname: "simple-icons:docker", style: { color: "#1488C6" } },
        { skillName: "Kubernetes", fontAwesomeClassname: "simple-icons:kubernetes", style: { color: "#326CE5" } },
        { skillName: "Azure DevOps", fontAwesomeClassname: "simple-icons:azuredevops", style: { color: "#0078D7" } },
        { skillName: "Microsoft Entra ID", fontAwesomeClassname: "simple-icons:microsoft", style: { color: "#F25022" } },
      ],
    },
    {
      title: "Testing & API Tools",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Writing unit tests using xUnit and NUnit",
        "⚡ Mocking dependencies using Moq for isolated testing",
        "⚡ Validating API requests and responses using Swagger and Postman",
      ],
      softwareSkills: [
        { skillName: "xUnit", fontAwesomeClassname: "simple-icons:testcafe", style: { color: "#FF8C00" } },
        { skillName: "Swagger", fontAwesomeClassname: "simple-icons:swagger", style: { color: "#85EA2D" } },
        { skillName: "Postman", fontAwesomeClassname: "simple-icons:postman", style: { color: "#FF6C37" } },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/riteshsargam/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/ritesh_sargam00",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Malla Reddy College of Engineering and Technology",
      subtitle: "B.Tech. in Electronics and Communication Engineering",
      logo_path: "btech.png",
      alt_name: "IIITDM Kurnool",
      duration: "2021 - 2024",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like Java, DBMS, Cloud Computing, CA, AI etc.",
        "⚡ Apart from this, I have done courses on Full Stack Development.",
        "⚡ Achieved finalist position in Smart India Hackathon 2022, standing out among 1,00,000+ participants nationwide for innovative problem-solving skills.",
      ],
      website_link: "https://mrcet.com/",
    },
    {
      title: "Government Polytechnic Siddipet",
      subtitle: "Diploma in Electronics and Communication",
      logo_path: "diploma.png",
      alt_name: "Indiana University Bloomington",
      duration: "2018 - 2021",
      descriptions: [
        "⚡ Worked on several hands-on projects related to circuit design and embedded systems.",
        "⚡Served as Class Representative for 3 consecutive years in Diploma."
      ],
      website_link: "https://gptsdpt.dte.telangana.gov.in/showView?div_id=19",
    },
    {
      title: "St. Peter's Central Public School",
      subtitle: "10th Grade Education Level",
      logo_path: "10th.png",
      alt_name: "Indiana University Bloomington",
      duration: "2018",
      descriptions: [
        "⚡ Completed secondary education under the CBSE curriculum."
      ],
      website_link: "https://www.stpeterscentralpublicschool.com/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Back-End Developer",
      subtitle: "- Meta",
      logo_path: "meta.jpg",
      certificate_link:
        "https://coursera.org/share/ef310ace3a96f3d291f2d98982781903",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "APIs",
      subtitle: "- Meta",
      logo_path: "meta.jpg",
      certificate_link:
        "https://coursera.org/share/0b38e152c39856af446dd6f53710619a",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Front-End Developer",
      subtitle: "- Meta",
      logo_path: "meta.jpg",
      certificate_link:
        "https://coursera.org/share/8089c5084470ca9f639abb68cffb9b5e",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description: 
  "I am a passionate .NET Developer with hands-on experience in building scalable microservices, cloud-native applications, and modern web solutions using ASP.NET Core, Angular, and Azure. I have worked on end-to-end software development including backend APIs, frontend interfaces, and DevOps pipelines. With a solid foundation in clean architecture and cloud technologies, I strive to deliver secure, high-performing, and maintainable solutions. I’m also enthusiastic about continuous learning, contributing to innovative projects, and collaborating with tech communities.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Full-Stack .NET Developer (Project-Based Experience)",
          company: "Personal Projects",
          company_url: "https://github.com/riteshsargam",
          logo_path: "asp.net.png",
          duration: "",
          location: "",
          description:
            "Worked on multiple full-stack applications using ASP.NET Core, Angular, and SQL Server. Built microservices architecture with Docker and Kubernetes, implemented secure authentication using Microsoft Entra ID B2C, and automated CI/CD pipelines with Azure DevOps. Designed and deployed cloud-native solutions on Azure using AKS, Redis, and API Gateway (Ocelot/Azure API Management).",
          color: "#000000",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create ASP.NET CORE projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile.png",
    description:
      "I'm currently open to full-time opportunities in software development. If you're looking for someone skilled in .NET technologies, microservices, cloud-native applications, or full-stack web development with ASP.NET Core and Angular — I'd love to connect!",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://codecraft-blog-hub.lovable.app/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Hyderabad, Telengana, India",
    locality: "Moosapet",
    country: "India",
    region: "Telangana",
    postalCode: "500018",
    streetAddress: "Moosapet",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/uD2MGXWPgspVXrrC7",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};